import { Box, Card, CardMedia } from '@mui/material'

export function CardImage({ property, images, selectedImage, hasImages }) {
  return (
    <Card sx={{ mb: 3, height: 500, overflow: 'hidden' }}>
      {hasImages ? (
        <Card
          sx={{
            mb: 3,
            height: 500,
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          {/* Fundo borrado */}
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              backgroundImage: `url(${images[selectedImage]?.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              filter: 'blur(20px)',
              transform: 'scale(1.2)',
              opacity: 0.5
            }}
          />

          {/* Imagem principal */}
          <Box
            component='img'
            src={images[selectedImage]?.image}
            alt={property.title}
            sx={{
              position: 'relative',
              width: '100%',
              height: '100%',
              objectFit: 'contain'
            }}
          />
        </Card>
      ) : (
        <CardMedia
          component='img'
          image='/placeholder-house.jpg'
          alt={property.title}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'contain'
          }}
        />
      )}
    </Card>
  )
}
